const config = {
  "secretKey": "$Hj7aF#k9l*D@v!3G",
  "numberOfRows": 100,
  "authMethod": "JWT",
  "endPoint":
    process.env.REACT_APP_TARGET === "dev"
      ? `${window.location.origin}/Millada_BE_ai_millennium`      // TEST 10.10.10.122: same-origin (:448) -> bez CORS (REACT_APP_TARGET=dev)
      : process.env.NODE_ENV === "production"
        ? `${window.location.origin}/MillAI_BE`        // PROD/DEV: origin = protokol+host aktuálnej stránky (http aj https, ľubovoľný host)
        : "http://localhost:8080",                           // lokalne debugovanie
  "subDir" : "/",
  "imgAllowed": false,
  "msgReviewsAllowed" : true,
  "jwtAllowed": true,
  "adAllowed" : true,
  "adConfig": {
    "clientId": "b95da68a-91eb-4946-a62b-cea557557428",
    "authority":"https://login.microsoftonline.com/f9eb7c2a-37a3-4a1e-aa8b-d5bd0ecbe9ab",
    "redirectUri": window.location.origin, // protokol+host aktuálnej stránky (http na localhoste, https v prode)
    "scopes": ["User.Read"]
  }
}
export default config;